"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/account_type.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountTypeToJSON = exports.accountTypeFromJSON = exports.AccountType = void 0;
/* eslint-disable */
exports.AccountType = {
    ACCOUNT_TYPE_UNSPECIFIED: "ACCOUNT_TYPE_UNSPECIFIED",
    ACCOUNT_TYPE_PARTICULAR: "ACCOUNT_TYPE_PARTICULAR",
    ACCOUNT_TYPE_SOLO_COMPANY: "ACCOUNT_TYPE_SOLO_COMPANY",
    ACCOUNT_TYPE_COMPANY: "ACCOUNT_TYPE_COMPANY",
    ACCOUNT_TYPE_INVESTMENT_FUND: "ACCOUNT_TYPE_INVESTMENT_FUND",
    ACCOUNT_TYPE_ASSOCIATION: "ACCOUNT_TYPE_ASSOCIATION",
    ACCOUNT_TYPE_STATE_AGENCY: "ACCOUNT_TYPE_STATE_AGENCY",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function accountTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "ACCOUNT_TYPE_UNSPECIFIED":
            return exports.AccountType.ACCOUNT_TYPE_UNSPECIFIED;
        case 1:
        case "ACCOUNT_TYPE_PARTICULAR":
            return exports.AccountType.ACCOUNT_TYPE_PARTICULAR;
        case 2:
        case "ACCOUNT_TYPE_SOLO_COMPANY":
            return exports.AccountType.ACCOUNT_TYPE_SOLO_COMPANY;
        case 3:
        case "ACCOUNT_TYPE_COMPANY":
            return exports.AccountType.ACCOUNT_TYPE_COMPANY;
        case 4:
        case "ACCOUNT_TYPE_INVESTMENT_FUND":
            return exports.AccountType.ACCOUNT_TYPE_INVESTMENT_FUND;
        case 5:
        case "ACCOUNT_TYPE_ASSOCIATION":
            return exports.AccountType.ACCOUNT_TYPE_ASSOCIATION;
        case 6:
        case "ACCOUNT_TYPE_STATE_AGENCY":
            return exports.AccountType.ACCOUNT_TYPE_STATE_AGENCY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.AccountType.UNRECOGNIZED;
    }
}
exports.accountTypeFromJSON = accountTypeFromJSON;
function accountTypeToJSON(object) {
    switch (object) {
        case exports.AccountType.ACCOUNT_TYPE_UNSPECIFIED:
            return "ACCOUNT_TYPE_UNSPECIFIED";
        case exports.AccountType.ACCOUNT_TYPE_PARTICULAR:
            return "ACCOUNT_TYPE_PARTICULAR";
        case exports.AccountType.ACCOUNT_TYPE_SOLO_COMPANY:
            return "ACCOUNT_TYPE_SOLO_COMPANY";
        case exports.AccountType.ACCOUNT_TYPE_COMPANY:
            return "ACCOUNT_TYPE_COMPANY";
        case exports.AccountType.ACCOUNT_TYPE_INVESTMENT_FUND:
            return "ACCOUNT_TYPE_INVESTMENT_FUND";
        case exports.AccountType.ACCOUNT_TYPE_ASSOCIATION:
            return "ACCOUNT_TYPE_ASSOCIATION";
        case exports.AccountType.ACCOUNT_TYPE_STATE_AGENCY:
            return "ACCOUNT_TYPE_STATE_AGENCY";
        case exports.AccountType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.accountTypeToJSON = accountTypeToJSON;
//# sourceMappingURL=account_type.js.map